export const config = {
	version: 'v1.0.0',
	magazine: 'http://j.chpsa.org.cn'
}